const meta = { auth: 'Amministratore' }

const routes = [
  {
    path: '/login',
    component: () => import('layouts/Login.vue'),
    meta: { auth: false },
    name: 'login'
  },
  {
    path: '/',
    redirect: '/clients'
  },
  {
    path: '/',
    component: () => import('layouts/Master.vue'),
    children: [
      { path: 'clients', name: 'clients', component: () => import('pages/Clients.vue'), meta: { auth: true } },
      { path: 'renewals', name: 'renewals', component: () => import('pages/Renewals.vue'), meta: { auth: true } },
      { path: 'banks', name: 'banks', component: () => import('pages/Banks.vue'), meta },
      { path: 'insurances', name: 'insurances', component: () => import('pages/Insurances.vue'), meta },
      { path: 'users', name: 'users', component: () => import('pages/Users.vue'), meta },
      { path: 'proveniences', name: 'proveniences', component: () => import('pages/Proveniences.vue'), meta },
      { path: 'acceptances', name: 'acceptances', component: () => import('pages/Acceptances.vue'), meta },
      // { path: 'reports', name: 'reports', component: () => import('pages/Reports.vue'), meta },
      { path: 'release_notes', name: 'release_notes', component: () => import('pages/ReleaseNotes.vue'), meta }
    ]
  },
  {
    path: '/403',
    component: () => import('pages/Error403.vue')
  },

  {
    path: '*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
